<!--
 * @Author: 张天昊
 * @Date: 2024-05-21 15:20:05
 * @LastEditTime: 2024-06-28 15:18:12
 * @LastEditors: 张天昊
 * @Description: 顶层的详情Tab
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/DetailTabs.vue
-->
<script lang="ts">
import { defineComponent, onMounted, ref, watch, provide } from 'vue';
import ItineraryInfoPanel from './ItineraryInfoPanel.vue';
import TravelAgencyPanel from './TravelAgencyPanel.vue';
import GuidePanel from './GuidePanel.vue';
import VehiclePanel from './VehiclePanel.vue';
import FilePanel from './FilePanel.vue';
import ModifyHistoryPanel from './ModifyHistoryPanel.vue';
import { useTabsLineWidth } from '../composables/useTabsLineWidth';
import { useAuxiliaryInfoPanelAnchor } from '../composables/useAuxiliaryInfoPanelAnchor';
import { useNavBarHeight } from '@/composables/useNavBarHeight';

export default defineComponent({
  setup(_, context) {
    const active = ref(0);
    const tabsInst = ref();
    const panelComponents = {
      行程信息: ItineraryInfoPanel,
      旅行社: TravelAgencyPanel,
      导游: GuidePanel,
      交通: VehiclePanel,
      附件: FilePanel,
      变更记录: ModifyHistoryPanel
    };
    const tabsInfo = Object.keys(panelComponents);

    const { lineWidth, resizeLineWidth } = useTabsLineWidth(tabsInst);
    const { panelInsts, handleServiceCardLink } =
      useAuxiliaryInfoPanelAnchor(active);

    provide('tabsInst', tabsInst);

    const { navBarHeight } = useNavBarHeight();

    return {
      navBarHeight,
      panelComponents,
      tabsInfo,
      tabsInst,
      panelInsts,
      active,
      lineWidth,
      resizeLineWidth,
      handleServiceCardLink
    };
  }
});
</script>

<template>
  <van-tabs
    v-model="active"
    class="custom-tabs"
    ref="tabsInst"
    color="#36B374"
    title-active-color="#36B374"
    title-inactive-color="#1E2226"
    :swipe-threshold="3"
    :line-width="lineWidth"
    :line-height="2"
    :lazy-render="false"
    :offset-top="navBarHeight"
    sticky
    @change="resizeLineWidth"
  >
    <van-tab
      v-for="title in tabsInfo"
      :key="title"
      :title="title"
      class="pb-22"
    >
      <components
        :is="panelComponents[title]"
        ref="panelInsts"
        @link="handleServiceCardLink"
      />
    </van-tab>
  </van-tabs>
</template>

<style lang="less" scoped>
.custom-tabs {
  &:deep(.van-sticky--fixed) {
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.05);
  }
  &:deep(.van-tabs__wrap) {
    height: 100%;
  }
  &:deep(.van-tabs__nav--line) {
    padding-bottom: 16px;
  }
  &:deep(.van-tabs__nav--line.van-tabs__nav--complete) {
    padding-left: 0;
    padding-right: 0;
    margin-left: -2px;
    margin-right: -2px;
  }
  &:deep(.van-tab) {
    padding-left: 14px;
    padding-right: 14px;
    padding-top: 15px;
    padding-bottom: 7px;
    font-size: 16px;
    line-height: 22px;
  }
  &:deep(.van-tab--active) {
    font-weight: 600;
  }
  &:deep(.van-tabs__line) {
    bottom: 16px;
  }
}
</style>
